export default __webpack_public_path__ + "static/media/YOIKER.d4221780.png";